<div class="error-wrapper" *ngIf="state.showError">
  <div class="header">
    <img src="{{ errorLabelAndIcon.icon }}" alt="{{ errorLabelAndIcon.label }}" class="pr-2" /><span>Error</span>
  </div>
  <div class="message" *ngFor="let err of dataTestRunResult?.response?.error_messages; trackBy: trackBy">{{ err }}</div>
  <div class="message" *ngIf="dataTestRunResult?.httpErrorOccurred">
    An error occurred while trying to execute the test
  </div>
</div>

<div class="success-wrapper" *ngIf="state.showSuccess">
  <div class="header">
    <img src="{{ successLabelAndIcon.icon }}" alt="{{ successLabelAndIcon.label }}" class="pr-2" />
    <span>Test run successful</span
    ><span *ngIf="state.failedRowsCount">. Number of failed rows: {{ state.failedRowsCount }}</span>
  </div>
</div>
